import React from 'react'
import clsx from 'clsx'
import { MineProject } from 'models/ApiModels'
import PriceText from 'components/PriceText'
import LabelInfo from './index'
import stylesGlobal from 'stylesGlobal.module.scss'

type LabelInfoPriceProps = {
  className?: string
  component?: 'div' | 'span'
  mineProject?: MineProject
}

const LabelInfoPrice: React.FC<LabelInfoPriceProps> = props => {
  const { component, mineProject } = props

  const network = mineProject?.network
  const price = mineProject?.current_price
  const start_price = BigInt(mineProject?.start_price ?? 0)
  const end_price = BigInt(mineProject?.end_price ?? 0)

  const priceDirection =
    start_price === end_price ? undefined : start_price > end_price ? 'down' : 'up'

  return (
    <LabelInfo
      className={stylesGlobal.MarginBottom16}
      component={component}
      title="Minting Price"
      titleTooltip={
        priceDirection ? (
          <>
            <span className={clsx(stylesGlobal.DisplayBlock, stylesGlobal.MarginBottom4)}>
              ↑ The price is increasing with each mint.
            </span>
            <span className={stylesGlobal.DisplayBlock}>
              ↓ The price is decreasing with each mint.
            </span>
          </>
        ) : undefined
      }
      content={
        <PriceText
          price={price || '0'}
          network={network || 'ETHEREUM'}
          unitMode={'symbol'}
          priceDirection={priceDirection}
        />
      }
    />
  )
}

export default LabelInfoPrice
